var map = {
	"./afflictionwarlock.png": 9958,
	"./arcanemage.png": 3860,
	"./armswarrior.png": 6019,
	"./assassinationrogue.png": 8188,
	"./augmentationevoker.png": 3222,
	"./balancedruid.png": 3904,
	"./beastmasteryhunter.png": 5658,
	"./blooddeathknight.png": 9581,
	"./brewmastermonk.png": 6967,
	"./demonologywarlock.png": 2120,
	"./destructionwarlock.png": 71,
	"./devastationevoker.png": 6966,
	"./disciplinepriest.png": 499,
	"./elementalshaman.png": 3131,
	"./enhancementshaman.png": 5734,
	"./feraldruid.png": 1652,
	"./firemage.png": 370,
	"./frostdeathknight.png": 539,
	"./frostmage.png": 9310,
	"./furywarrior.png": 7736,
	"./guardiandruid.png": 4333,
	"./havocdemonhunter.png": 9246,
	"./holypaladin.png": 8685,
	"./holypriest.png": 9011,
	"./marksmanshiphunter.png": 6466,
	"./mistweavermonk.png": 6366,
	"./outlawrogue.png": 688,
	"./preservationevoker.png": 3552,
	"./protectionpaladin.png": 5988,
	"./protectionwarrior.png": 6123,
	"./restorationdruid.png": 7988,
	"./restorationshaman.png": 9068,
	"./retributionpaladin.png": 7384,
	"./shadowpriest.png": 3325,
	"./subtletyrogue.png": 5634,
	"./survivalhunter.png": 7240,
	"./unholydeathknight.png": 5506,
	"./vengeancedemonhunter.png": 2437,
	"./windwalkermonk.png": 3605
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1835;